import { render } from "./RearrangeSpeakersModal.vue?vue&type=template&id=b041fed8&scoped=true"
import script from "./RearrangeSpeakersModal.vue?vue&type=script&lang=js"
export * from "./RearrangeSpeakersModal.vue?vue&type=script&lang=js"

import "./RearrangeSpeakersModal.vue?vue&type=style&index=0&id=b041fed8&scoped=true&lang=css"

import exportComponent from "/Users/callum/Dev/saxton/saxton-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b041fed8"]])

export default __exports__